import React, { Component } from "react";
import { Pagination} from "@deere/ux.uxframe-react";
import { MAX_VISIBLE_PAGES } from "../shared/Constants";

class PaginationData extends Component {
    constructor(props) {
        super(props);
         this.state = {
            total: this.props.pageData.total,
            page: this.props.pageData.page,
            perPage:this.props.pageData.perPage
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.pageData !== state.pageData) {
            return {
                total: props.pageData.total,
            };
        }
    }

    handleChange = page => {
        this.setState({page: page}, () => {
          if (this.props.onChange) {
            this.props.onChange(this.state);
          }
        })
      };


    updatePage(page) {
        this.setState({page: page});
        this.handleChange(page);
    }

    nextPage = () => {
        const { total, page, perPage } = this.state;
        const max = Math.ceil(total / perPage);

        if (page < max) {
            this.updatePage(page + 1);
        }
    };

    previousPage = () => {
        const {page} = this.state;

        if (page > 1) {
            this.updatePage(page - 1);
        }
    };

    pageItem = (paginationPage, pageDisplay) => {
        let pageDisplayActual = pageDisplay;

        if (pageDisplay === undefined) {
            pageDisplayActual = paginationPage;
        }

        return (
            <Pagination.Item
                active={paginationPage === this.state.page}
                key={paginationPage}
                onClick={() => this.updatePage(paginationPage)}
            >
                {pageDisplayActual}
            </Pagination.Item>
        );
    };

    get pageItems() {
        const {total, page, perPage} = this.state;
        const lastPage = Math.ceil(total / perPage);
        const pageItems = [this.pageItem(page)];
        let delta = 1;
        let addedPages = 1;
        let visiblePages = 1;
        let firstPageAdded = page;
        let lastPageAdded = page;

        // add pages around the current page until we run out
        while (
            visiblePages < MAX_VISIBLE_PAGES &&
            visiblePages < lastPage &&
            addedPages > 0
            ) {
            addedPages = 0;

            if (page - delta > 0) {
                pageItems.unshift(this.pageItem(page - delta));
                firstPageAdded = page - delta;
                addedPages += 1;
            }
            if (page + delta <= lastPage) {
                pageItems.push(this.pageItem(page + delta));
                lastPageAdded = page + delta;
                addedPages += 1;
            }

            visiblePages += addedPages;
            delta += 1;
        }
        // if we ran out of pages when rendering them then we need to show the first and last page
        if (visiblePages !== lastPage) {
            if (firstPageAdded !== 1) {
                pageItems.shift();
                pageItems.unshift(this.pageItem(1, "1..."));
            }
            if (lastPageAdded !== lastPage) {
                pageItems.pop();
                pageItems.push(this.pageItem(lastPage, `...${lastPage}`));
            }
        }

        return pageItems;
    }

    get currentPageResultsStart() {
        return (this.state.page - 1) * this.state.perPage + 1;
    }

    get currentPageResultsEnd() {
        const {total, perPage} = this.state;
        const start = this.currentPageResultsStart;
        const end = start + perPage - 1;

        return end < total ? end : total;
    }

    render() {
        const {total, page, perPage} = this.state;
        const lastPage = Math.ceil(total / perPage);
        return (
            <Pagination
                ariaLabel="Page navigation example"
                pageResults={true}
                text={`${this.currentPageResultsStart} - ${this.currentPageResultsEnd} of ${total} Results`}
                className="uxf-pagination-mobile-first justify-content-center"
            >
                <Pagination.Item aria-label="previous"></Pagination.Item>
                <Pagination.Item disabled={page === 1} onClick={this.previousPage}>
                    Previous
                </Pagination.Item>
                {this.pageItems}
                <Pagination.Item
                    disabled={page === lastPage}
                    onClick={this.nextPage}
                >
                    Next
                </Pagination.Item>
                <Pagination.Item aria-label="next"></Pagination.Item>
            </Pagination>
        )
    }
}
export default PaginationData;